export const hasReadPdf = (startTime, endTime, pageCount, avgTimePerPage = 0) => {
  const requiredTime = pageCount * avgTimePerPage * 1000;
  const actualTime = endTime - startTime;
  return actualTime >= requiredTime;
};

export const hasWatchedVideo = (watchedSeconds, duration, threshold = 0.9) => {
  return watchedSeconds >= duration * threshold;
};


